/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AdminAccount.css';
import Calendar from '../../components/Calendar'
import Link from '../../components/Link'
import loadingGif from './loading.gif'
import AdminBackNav from '../adminBackNav/adminBackNav';

const typeList=[
  {
    class:'全部账号',
    type:0
  },{
    class:'试用账号',
    type:1
  },{
    class:'正式账号',
    type:2
  },{
    class:'管理员',
    type:3
  }
]

const tableTit=[
  'ID',
  '姓名',
  '手机号',
  '邮箱',
  '注册品牌',
  '职位',
  '已点击品牌',
  '注册时间',
  '到期时间',
  '账号类型',
  '备注'
]

class AdminAccount extends React.Component {
  
  constructor(){
    super()
    this.state={
      phone:'',
      email:'',
      name:'',
      brandName:'',
      accountType:0,

      timeStartShow:false,
      timeEndShow:false,
      timeStart:'',
      timeEnd:'',
      tableData:[],
      loadding:false,
    }
    this.isCalendarCon=false

    this.saveToState=this.saveToState.bind(this)
    this.saveFile=this.saveFile.bind(this)
    this.enCalendarCon=this.enCalendarCon.bind(this)
    this.ovCalendarCon=this.ovCalendarCon.bind(this)
    this.closeCalendarStart=this.closeCalendarStart.bind(this)
    this.closeCalendarEnd=this.closeCalendarEnd.bind(this)
    
  }
  closeCalendarStart=(time)=>{
    this.setState({timeStart:time,timeStartShow:false})
  }
  closeCalendarEnd=(time)=>{
    this.setState({timeEnd:time,timeEndShow:false})
  }
  
  enCalendarCon=()=>{
    this.isCalendarCon=true
  }
  ovCalendarCon=()=>{
    this.isCalendarCon=false
  }

  saveFile=()=>{
    // 保存数据到本地
    console.log(1)
    const {phone,email,name,brandName,accountType,timeStart,timeEnd}=this.state
    
    const url=`/dbrankCMS/saveAccountFile?type=${accountType}&phone=${phone}&email=${email}&name=${name}&brand=${brandName}&registerStart=${timeStart}&registerEnd=${timeEnd}`


    const a = document.createElement('a');
    a.textContent = 'download';
    a.download = 'filename';
    a.href =url;
    a.click();
  }


  saveToState=(e)=>{
    const {name,value}=e.target
    this.setState({
      [name]:value,
      
    })
  }
  getAccountList=()=>{
    const {phone,email,name,brandName,accountType,timeStart,timeEnd}=this.state
    // const url=`/getAccountList?registerStart=${timeStart}&registerEnd=${timeEnd}&type=${accountType}&phone=${phone}&email=${email}&name=${name}&brand=${brandName}`
    this.setState({loadding:true})
  
    const url=`/dbrankCMS/getAccountList?type=${accountType}&phone=${phone}&email=${email}&name=${name}&brand=${brandName}&registerStart=${timeStart}&registerEnd=${timeEnd}`
    // const url=`http://10.0.58.22:8082/getAccountList?type=${accountType}&phone=${phone}&email=${email}&name=${name}&brand=${brandName}&registerStart=${timeStart}&registerEnd=${timeEnd}`

    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
    .then(response=>response.json())
    .then(data=>{
      console.log(data,'data')
      console.log(data.errorCode,data.errorCode==2)
      
      this.setState({loadding:false})
      
      if(data.errorCode==2){
        alert('请重新登录！')
        this.setState({tableData:[],})
      }else{
        this.setState({tableData:data})
        
      }
      
    })
    .catch(e=>{
      console.log('err',e)
      alert('请求失败！')
      this.setState({tableData:[]})
    })



  }


  renderTable=(tableData)=>{
    const {loadding}=this.state
    return(
      <div>
        {loadding?
        <div><img src={loadingGif} /></div>
      :<table cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              {tableTit.map((i,index)=>
                <th key={index}>{i}</th>
              )}
            </tr>
          </thead>
          <tbody>
            {tableData.map((i,index)=>{
             
              return (
                <tr key={index}>
                  <th>{i.id}</th>
                  <td><Link to={`/adminAccountInfo?id=${i.id}`}>{i.name}</Link></td>
                  <td>{i.phone}</td>
                  <td>{i.email}</td>
                  <td>{i.brand}</td>
                  <td>{i.job}</td>
                  <td>{i.clickBrand}</td>
                  <td>{i.timeStart}</td>
                  <td>{i.timeEnd}</td>
                  <td>{i.type}</td>
                  <td>{i.note}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        }
        </div>
    )
  }



  render() {
    const {loadding,phone,email,name,brandName,accountType,timeStart,timeEnd,timeStartShow,timeEndShow,tableData}=this.state
    return (

      
          <div className={s.root}>
            <AdminBackNav></AdminBackNav>

        <div className={s.container}>
          <h1>账号管理</h1>
          <div className={s.listBox}>
            <ul>
              <li>
                <label>手机号：</label>
                <input  type='text' value={phone}  name='phone' onChange={this.saveToState}/>
                <label>邮箱：</label>
                <input  type='text' value={email}  name='email' onChange={this.saveToState}/>
                <label>姓名：</label>
                <input  type='text' value={name}  name='name' onChange={this.saveToState}/>
              </li>
              <li>
                <div>
                  <div className={s.timeItem} onBlur={()=>!this.isCalendarCon?this.setState({timeStartShow:false}):null}  tabIndex='0'>
                    <span className={s.timeInfoTxt}>注册时间：</span>
                    <div className={s.month} onClick={()=>this.setState({timeStartShow:!this.state.timeStartShow})}>
                        <span className={s.monthTxt} >
                          {timeStart}
                          {timeStart!=''?
                          <i className={s.monthTxtClose} onClick={()=>this.setState({timeStart:''})}>清空</i>
                          :null}
                        </span>
                    </div>
                    
                    <Calendar  isShow={timeStartShow} close={this.closeCalendarStart} cycle='日榜'
                        en={this.enCalendarCon}   ov={this.ovCalendarCon} otherlayout={true}
                    />
                  </div>
                  <div className={s.timeItem} onBlur={()=>!this.isCalendarCon?this.setState({timeEndShow:false}):null}  tabIndex='0'>
                    <span className={s.timeInfoTxt}>结束时间：</span>
                    <div className={s.month} onClick={()=>this.setState({timeEndShow:!this.state.timeEndShow})}>
                        <span className={s.monthTxt} >
                          {timeEnd}
                          {timeEnd!=''?
                          <i className={s.monthTxtClose} onClick={()=>this.setState({timeEnd:''})}>清空</i>
                          :null}
                        </span>
                    </div>
                    <div className={s.monthEnd}>
                      <Calendar  isShow={timeEndShow} close={this.closeCalendarEnd} cycle='日榜'
                          en={this.enCalendarCon} hasMore={true}  ov={this.ovCalendarCon} otherlayout={true}
                      />
                    </div>
                  </div>
                </div>
                
              </li>
              <li>
                <label>账号类型：</label>
                  <select onChange={(e)=>this.setState({accountType:e.target.value})}
                    value={accountType}>
                    {typeList.map(i=>
                      <option key={i.type} value={i.type}>{i.class}</option>
                    )}
                  </select>
              
                <label>品牌：</label>
                <input  type='text' value={brandName}  name='brandName' onChange={this.saveToState}/>
              </li>

            </ul>
            <div onClick={this.getAccountList} className={s.seaBtn} >搜索</div>
            <div onClick={this.saveFile} className={s.download}>点击导出数据</div>
          </div>
          {tableData.length>0?
            <div className={s.tableBox}>
              {this.renderTable(tableData)}
            </div>
          :null}
          
        </div>
      </div>
        
      
    
    
    );
  }
}

export default withStyles(s)(AdminAccount);



// WEBPACK FOOTER //
// src/routes/adminAccount/AdminAccount.js